import React, { useState, useEffect } from "react";
import { QRCodeSVG } from "qrcode.react";
import "./QRCode.css";
import { useAnalytics } from "../../hooks/useAnalytics";

const QRCodeComponent = () => {
  useAnalytics();
  
  // State for loading and error handling
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);



  const CUSTOM_REDIRECT_URL = `${process.env.REACT_APP_API}/qrcode/download`;



  // Function to handle QR code scan
  const handleDownload = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ALIAS}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "User-Agent": navigator.userAgent, // Backend will use this for detection
          },
        }
      );

      if (!response.ok) {
        error = new Error("Internal Server Error (500)");
      }

      const data = await response.json();

      window.location.href = data.redirectUrl;
    } catch (err) {
      setError(err.message);
      window.location.href = "https://www.booking.nimblecasa.com";
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="qr-card">
      <div className="qr-card-content">
        {/* QR Code Section */}
        {/* <div className="qr-code-container">
          <QRCodeSVG
          
            value={process.env.REACT_APP_API_ALIAS}
            size={200}
            level="H"
            includeMargin={true}
          />
        </div> */}

        {/* Instructions */}
        {/* <p className="qr-instructions">Scan the QR code to download our app</p> */}

        {/* Store Badges */}
        <div className="store-badges">
          {/* App Store Badge */}
          <a
            href={`${process.env.REACT_APP_APPLE_STORE}`}
            target="_blank"
            rel="noopener noreferrer"
            className="store-link"
          // onClick={(e) => {
          //   e.preventDefault();
          //   handleDownload();
          // }}
          >
            <img
              src="./AppStore.png"
              alt="Download on App Store"
              className="store-badge"
            />
          </a>

          {/* Google Play Badge */}
          <a
            href={`${process.env.REACT_APP_GOOGLE_STORE}`}
            target="_blank"
            rel="noopener noreferrer"
            className="store-link"
          // onClick={(e) => {
          //   e.preventDefault();
          //   handleDownload();
          // }}
          >
            <img
              src="./GooglePlay.png"
              alt="Get it on Google Play"
              className="store-badge"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default QRCodeComponent;
